import { BottomNavigation } from "../../molcules/BottomNavigation";
import { Header } from "../../molcules/Header";
import * as S from "./mainTemplates.styles";

interface MainProps {
  pageTitle?: string;
  children: React.ReactElement;
  padding?: string;
  background?: string;
  gap?: string;
}

export const MainTemplates = ({
  pageTitle,
  children,
  padding,
  background,
  gap,
}: MainProps) => {
  return (
    <S.MainTemplates>
      <Header background={background} pageTitle={pageTitle} />
      <S.ContentsSection padding={padding} gap={gap}>
        {children}
      </S.ContentsSection>
      <BottomNavigation />
    </S.MainTemplates>
  );
};
